import ImageWrapper from './ImageWrapper';
import f1 from '../img/footer-img1.jpg';
import f2 from '../img/footer-img2.jpg';
import f3 from '../img/footer-img3.jpg';
import f4 from '../img/footer-img4.jpg';
import f5 from '../img/footer-img5.jpg';
import f6 from '../img/footer-img6.jpg';
import f7 from '../img/footer-img7.jpg';
import f8 from '../img/footer-img8.jpg';
import Icon from './Icon';

function Footer() {
    return (
        <>
            <div className="relative w-full flex items-center justify-center flex-wrap lg:flex-nowrap">
                <ImageWrapper
                    src={f1}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f2}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f3}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f4}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f5}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f6}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f7}
                    className="w-1/4 lg:w-1/8"
                />
                <ImageWrapper
                    src={f8}
                    className="w-1/4 lg:w-1/8"
                />
                <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noreferrer"
                    className="absolute rounded-full bg-white w-24 h-24 flex items-center justify-center group hover:bg-brand transition-all">
                    <Icon
                        name="instagram"
                        className="group-hover:stroke-white group-hover:w-8 group-hover:h-8 transition-all duration-300 stroke-brand w-6 h-6"
                    />
                </a>
            </div>
            <div className="bg-body pt-8 w-full">
                <div className="page__width flex flex-col lg:flex-row items-center justify-between">
                    <div className="w-full lg:w-1/2 flex flex-col">
                        <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                            From Plans to Perfection
                        </h2>
                        <p className="w-full lg:w-5/6 text-text text-base lg:text-lg text-center lg:text-start">
                            Passionate event planners and catering experts
                            dedicated to making your occasion extraordinary
                        </p>
                    </div>
                    <div className="w-full lg:w-2/5 flex flex-col lg:flex-row gap-4 lg:gap-0 mt-4 lg:mt-0">
                        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
                            <h3 className="text-xl lg:text-2xl text-white">
                                Address
                            </h3>

                            <p className="text-text text-base text-center lg:text-start">
                                25 Thurso House, Randolph Gardens, NW65EL <br />
                                London, United Kingdom
                            </p>
                        </div>
                        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start">
                            <h3 className="text-xl lg:text-2xl text-white">
                                Say Hello
                            </h3>

                            <a
                                href="mailto:mariyan.alekov@smoothaffairs.co.uk"
                                className="text-brand underline text-base text-center lg:text-start">
                                mariyan.alekov@smoothaffairs.co.uk
                            </a>
                            <p className="text-text text-base text-center lg:text-start">
                            +44 748 022 99 43
                            </p>
                        </div>
                    </div>
                </div>
                <div className="page__width h-[1px] bg-text mt-4"></div>
                <div className="page__width flex flex-col lg:flex-row items-center py-4 justify-center lg:justify-between">
                    <div className="flex flex-col lg:flex-row  items-center gap-4">
                        <p className="text-text text-base">
                            Smooth Affairs LLC
                        </p>
                        <div className="hidden lg:block w-1 h-1 bg-text rounded-full"></div>
                        <p className="text-text text-base">
                            All Rights Reserved
                        </p>
                        <div className="hidden lg:block w-1 h-1 bg-text rounded-full"></div>
                        <a
                            href="/terms"
                            className="text-text hover:underline hover:text-brand cursor-pointer text-base">
                            Terms & Conditions
                        </a>
                        <div className="hidden lg:block w-1 h-1 bg-text rounded-full"></div>
                        <a
                            href="/privacy-policy"
                            className="text-text hover:underline hover:text-brand cursor-pointer text-base">
                            Privacy Policy
                        </a>
                    </div>
                    <div className="lg:hidden page__width h-[1px] bg-text mt-4"></div>
                    <p className="mt-4 lg:mt-0 text-text text-base">
                        Designed & Developed by{' '}
                        <a
                            target="_blank"
                            href="cristiantirotta.com"
                            className="animated_link text-brand text-base">
                            TirottaWeb
                        </a>
                        💙
                    </p>
                </div>
            </div>
        </>
    );
}

export default Footer;
